import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateAccountSetting } from '../../store/auth/auth.actions';
import { showFeedback } from '../../store/ui/ui.actions';
import { Button, Dropdown, Input, Title } from '../shared';
import { selectAccount, selectIsAdmin } from '../../store/auth/auth.selector';
import { selectLang } from '../../store/ui/ui.selector';
import { translate } from '../../lib/lang.helper';
import { getUnitOfSpecie } from '../../lib/common.helpers';

const SeedStagesSize = () => {
  const dispatch = useDispatch<any>();
  const account = useSelector(selectAccount);
  const isAdmin = useSelector(selectIsAdmin);
  const lang = useSelector(selectLang);

  const sizeUnit = getUnitOfSpecie(account?.display_unit, 'size_mm');

  const [disabled, setDisabled] = useState(false);
  const [stages, setStages] = useState<{ size: number; time: number }[]>([]);

  useEffect(() => {
    if (account?.seed_stages_size && account.seed_stages_size.length > 0) {
      setStages(account.seed_stages_size);
    } else {
      setStages([{ size: 0, time: 0 }]);
    }
  }, [account?.seed_stages_size]);

  const handleSelectStagesCount = (val: string) => {
    let l = Number(val);
    let s = [...stages];

    while (s.length < l) s.push({ size: 0, time: 0 });
    s = s.splice(0, l);

    setStages(s);
  };

  const handleValueChange = (
    idx: number,
    key: 'size' | 'time',
    val: string,
  ) => {
    let s = [...stages];
    if (idx >= s.length) return;
    s[idx][key] = Number(val);
    setStages(s);
  };

  const handleSubmitClick = async () => {
    setDisabled(true);
    const res = await dispatch(
      updateAccountSetting({ seed_stages_size: stages }),
    );
    setDisabled(false);
    if (res === true) {
      dispatch(
        showFeedback({
          isMessage: true,
          message: translate(lang, 'Updated successfully'),
          type: 'success',
        }),
      );
    } else {
      dispatch(
        showFeedback({
          isMessage: true,
          message: translate(lang, res?.data?.message ?? 'Unknown error'),
          type: 'error',
        }),
      );
    }
  };

  return (
    <div className='mb-32'>
      <div className='d-flex mb-16 mt-27 align-center justify-between'>
        <Title size={6} color='black-3' align='default' fontWeight={500}>
          {translate(lang, '_many_stages_seeding_farm')}
        </Title>
      </div>
      <div className='ml-21'>
        <Dropdown
          label={translate(lang, '_instance_after_initial_seeding')}
          value={stages.length.toString()}
          options={['1', '2', '3', '4'].map(x => ({
            id: x,
            label: x,
            value: x,
          }))}
          onChange={handleSelectStagesCount.bind(this)}
        />
        <div className='mt-17'>
          {stages.map((item, idx) => (
            <div className='d-flex mt-17' key={idx}>
              <div className='w-100 mr-17'>
                <Input
                  type='number'
                  value={item.size.toString()}
                  label={translate(lang, '_expected_harvest_size')}
                  unit={sizeUnit}
                  disabled={disabled || !isAdmin}
                  onChange={e => handleValueChange(idx, 'size', e.target.value)}
                />
              </div>
              <div className='w-100 ml-17'>
                <Input
                  type='number'
                  value={item.time.toString()}
                  label={translate(lang, 'Growth time [months]')}
                  disabled={disabled || !isAdmin}
                  onChange={e => handleValueChange(idx, 'time', e.target.value)}
                />
              </div>
            </div>
          ))}
        </div>
        <Button
          className='mt-16 mb-16'
          type='fill'
          width='small'
          size={0}
          color='blue'
          onClick={handleSubmitClick}
          disabled={disabled || !isAdmin}
        >
          {translate(lang, 'Update')}
        </Button>
      </div>
    </div>
  );
};

export default SeedStagesSize;
